import React, { useEffect } from 'react';
import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import Nav from './components/Nav.js';
import Footer from './components/Footer.js';
import Home from './pages/Home.js';
import ProjectPage from './pages/ProjectPage.js';

// Scrolls to the #section in the URL, or to the top when changing pages.
const ScrollManager = () => {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        if (hash) {
            const el = document.getElementById(hash.slice(1));
            if (el) {
                el.scrollIntoView();
                return;
            }
        }
        window.scrollTo(0, 0);
    }, [pathname, hash]);

    return null;
};

export const AppRoutes = () => (
    <>
        <ScrollManager />
        <a href="#main" className="skip-link">Skip to content</a>
        <Nav />
        <main id="main">
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/projects/:slug" element={<ProjectPage />} />
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </main>
        <Footer />
    </>
);

const App = () => (
    <BrowserRouter>
        <AppRoutes />
    </BrowserRouter>
);

export default App;
